/* eslint-disable no-prototype-builtins */

/**
 * 判断类型
 * @param {value}
 * @returns {string}
 */
export const toRawType = (value) => {
    return Object.prototype.toString.call(value).slice(8, -1);
};
/**
 * 置空对象
 * @param {obj}
 */
export const emptyObject = (obj) => {
    if (toRawType(obj) !== 'Object') {
        console.log('param is not Object types');
        return;
    }
    for (const item in obj) {
        if (obj.hasOwnProperty(item)) {
            obj[item] = '';
        }
    }
};
/**
 * 打开对话框
 * @param flag
 */
export const dialogShow = (flag) => {
    if (toRawType(flag) !== 'Boolean') {
        console.log('param is not Boolean types');
        return;
    }
    flag = true;
};
/**
 * 关闭对话框
 * @param flag
 */
export const dialogClose = (flag) => {
    if (toRawType(flag) !== 'Boolean') {
        console.log('param is not Boolean types');
        return;
    }
    flag = false;
};

